// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.disable-field-jMLuez{padding:12px 0 24px}.disable-field-jMLuez .title-s26PF2{margin-bottom:8px;font-size:14px;font-weight:600}.input-XYeEI3.input-XYeEI3{padding-top:4px}.input-XYeEI3 .semi-input-suffix{cursor:pointer;padding:8px}.link-button-tWRlPA.link-button-tWRlPA.link-button-tWRlPA{background-color:transparent}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"disable-field": `disable-field-jMLuez`,
	"disableField": `disable-field-jMLuez`,
	"title": `title-s26PF2`,
	"input": `input-XYeEI3`,
	"link-button": `link-button-tWRlPA`,
	"linkButton": `link-button-tWRlPA`
};
export default ___CSS_LOADER_EXPORT___;
